import LegalPageLayout from "@/components/LegalPageLayout";
import usePageMeta from "@/hooks/usePageMeta";

const SUPPORT_EMAIL = "info@mayr-technologies.com";
const SUPPORT_EMAIL_LINK = `mailto:${SUPPORT_EMAIL}`;

const SectionCard = ({ heading, children }) => (
  <section className="rounded-2xl border border-white/[0.08] bg-white/[0.02] p-6 md:p-7">
    <h2 className="font-['Outfit'] text-xl md:text-2xl tracking-tight text-white">
      {heading}
    </h2>
    <div className="mt-3 font-['Manrope'] text-sm md:text-base leading-relaxed text-neutral-400 max-w-3xl">
      {children}
    </div>
  </section>
);

const SupportPage = () => {
  usePageMeta(
    "Support | Mayr Technologies",
    "Support information for Mayr Technologies products, services, platforms, and billing inquiries.",
  );

  return (
    <LegalPageLayout
      title="Support"
      intro="If you need help with our products, services, platforms, billing, or general inquiries, contact us using the details below."
    >
      <SectionCard heading="Mayr Technologies Support">
        <p>
          We are available for support requests related to our services and platforms.
        </p>
      </SectionCard>

      <SectionCard heading="Support Email">
        <a
          href={SUPPORT_EMAIL_LINK}
          className="text-neutral-200 underline decoration-white/30 underline-offset-4 transition-colors hover:text-white"
        >
          {SUPPORT_EMAIL}
        </a>
      </SectionCard>

      <SectionCard heading="Company">
        <p>Mayr Technologies</p>
      </SectionCard>

      <SectionCard heading="Website">
        <a
          href="https://mayr-technologies.com"
          className="text-neutral-200 underline decoration-white/30 underline-offset-4 transition-colors hover:text-white"
        >
          https://mayr-technologies.com
        </a>
      </SectionCard>

      <SectionCard heading="General Support">
        <p>
          For support with our platforms, systems, integrations, or service-related questions, email us at{" "}
          <a
            href={SUPPORT_EMAIL_LINK}
            className="text-neutral-200 underline decoration-white/30 underline-offset-4 transition-colors hover:text-white"
          >
            {SUPPORT_EMAIL}
          </a>
          .
        </p>
      </SectionCard>

      <SectionCard heading="Billing Support">
        <p>
          For billing-related questions, please include your full name, company name if applicable, and a clear description of the issue.
        </p>
      </SectionCard>

      <SectionCard heading="Availability">
        <p>Support is currently provided primarily by email.</p>
      </SectionCard>

      <SectionCard heading="Response Time">
        <p>We aim to respond as soon as reasonably possible during normal business days.</p>
      </SectionCard>

      <p className="pt-2 text-xs md:text-sm text-neutral-500 font-['Manrope']">Last updated: March 2026</p>
    </LegalPageLayout>
  );
};

export default SupportPage;
